import { lazy } from 'react'

// Route pages load on demand.
const ProcessModules = {
    List: lazy(() => import('./components/List')),
}
export default ProcessModules
